export const GET_KYC_DIGILOCKER_URL_SUCCESS = 'GET_KYC_DIGILOCKER_URL_SUCCESS';
export const GET_KYC_DIGILOCKER_URL = 'GET_KYC_DIGILOCKER_URL';

export type GetDigilockerUrlResponse = {
  uri: string;
};

// redux/types/digilocker.ts
export type DigilockerCallbackResponse = {
  fileId?: string;
  esignReferenceId?: string;
  [key: string]: unknown;
};

export const GET_DIGILOCKER_CALLBACK_SUCCESS = 'GET_DIGILOCKER_CALLBACK_SUCCESS';
export const GET_DIGILOCKER_CALLBACK = 'GET_DIGILOCKER_CALLBACK';

export const REDIRECT_KYC_UPDATE_SUCCESS = 'REDIRECT_KYC_UPDATE_SUCCESS';

export const ESIGN_KYC_DOCUMENT_SUCCESS = 'ESIGN_KYC_DOCUMENT_SUCCESS';
export const ESIGN_KYC_DOCUMENT = 'ESIGN_KYC_DOCUMENT';

export const UPDATE_DIGILOCKER_ADDRESS_SUCCESS = 'UPDATE_DIGILOCKER_ADDRESS_SUCCESS';
export const UPDATE_DIGILOCKER_ADDRESS = 'UPDATE_DIGILOCKER_ADDRESS';
